import React from 'react'

import {Box} from '@vio/atlas/helpers/Box'
import {SkeletonLoader} from '@vio/atlas/SkeletonLoader'

export const HotelDetailsLoading = () => (
  <Box marginBottom="s300">
    <SkeletonLoader width={252} />
    <SkeletonLoader width={175} />
  </Box>
)
